module.exports = __webpack_public_path__ + "static/media/aboutHeroM.418567f8.jpg";